import {IHttpService} from "angular";
import {IntegrationValidatorResult} from "./integrationValidatorResult";
import {IntegrationValidatorUrls} from "./integrationValidatorUrls";
import {integrationValidatorModule} from "./integrationValidatorModule";

export class IntegrationValidatorService {

    constructor(private $http: IHttpService, private integrationValidatorUrls: IntegrationValidatorUrls) {
    }

    getIntegrationDataSources() {
        return this.$http.get<string[]>(this.integrationValidatorUrls["validator.dataSources"]).then(response => response.data);
    }

    getAvailableInterfaces() {
        return this.$http.get<string[]>(this.integrationValidatorUrls["validator.interfaces"]).then(response => response.data);
    }

    testPublish(interfaceName: string, integrationDataSourceId: string) {
        return this.$http.post<IntegrationValidatorResult>(this.integrationValidatorUrls["validator"], null, {
            params: {
                interface: interfaceName,
                integrationDataSourceId
            }
        }).then(response => response.data);
    }
}

integrationValidatorModule.service("integrationValidatorService", IntegrationValidatorService);